import React from 'react';
import { Box } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

export interface StepCompletionStatus {
  isComplete: boolean;
  hasWarning: boolean;
}

const CustomStepIcon: React.FC<{
  active?: boolean;
  completed?: boolean;
  icon: React.ReactNode;
  completionStatus: StepCompletionStatus;
}> = ({ active = false, icon, completionStatus }) => {
  const { isComplete, hasWarning } = completionStatus;
  if (isComplete && !hasWarning)
    return (
      <Box
        aria-label='Step complete'
        sx={{
          width: 22,
          height: 22,
          borderRadius: '50%',
          backgroundColor: 'success.main',
          color: 'white !important',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 11,
          fontWeight: 600,
          flexShrink: 0,
          boxShadow: active ? theme => `0 0 0 3px ${theme.palette.success.main}22` : 'none',
        }}
      >
        <CheckIcon sx={{ fontSize: 14 }} />
      </Box>
    );
  if (hasWarning)
    return (
      <Box
        sx={{
          width: 22,
          height: 22,
          borderRadius: '50%',
          backgroundColor: 'warning.main',
          color: 'white !important',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 11,
          fontWeight: 600,
          flexShrink: 0,
        }}
      >
        !
      </Box>
    );
  return (
    <Box
      sx={{
        width: 22,
        height: 22,
        borderRadius: '50%',
        backgroundColor: 'primary.main',
        color: 'white !important',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 11,
        fontWeight: 600,
        flexShrink: 0,
        boxShadow: active ? theme => `0 0 0 3px ${theme.palette.primary.main}22` : 'none',
      }}
    >
      {icon}
    </Box>
  );
};

export default CustomStepIcon;
